import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=0dcaa878"
import script from "./Rooms.vue?vue&type=script&lang=js"
export * from "./Rooms.vue?vue&type=script&lang=js"
import style0 from "./Rooms.vue?vue&type=style&index=0&id=0dcaa878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports